"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _button = require("../../../button");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var YearButton = /*#__PURE__*/_react.default.memo(function (_ref) {
  var hasFocus = _ref.hasFocus,
      isCurrentYear = _ref.isCurrentYear,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      year = _ref.year;
  var ref = (0, _react.useRef)(null);

  var handleClick = function handleClick() {
    onClick(year);
  };

  (0, _react.useEffect)(function () {
    if (hasFocus && ref.current) {
      ref.current.focus();
    }
  }, [hasFocus]);
  return (0, _core.jsx)(_helperComponents.YearButtonBase, {
    isCurrentYear: isCurrentYear,
    onClick: handleClick,
    onKeyDown: onKeyDown,
    ref: ref,
    tabIndex: isCurrentYear ? 0 : -1,
    variant: _button.ButtonVariant.Tertiary
  }, year);
});

var _default = YearButton;
exports.default = _default;